import styled from "styled-components";

export default styled.textarea.attrs(props => ({
  rows: props.rows || 4
}))`
  width: auto;
  border-radius: ${props => props.theme.sizes.small}rem;
  border: 2px solid ${props => props.theme.grayscale?.g60};
  padding: ${props => props.theme.sizes.normal}rem;
  font-size: ${props => props.theme.fontSizes.p}rem;
  background-color: ${props => props.theme.colors.background};
  color: ${props => props.theme.colors.inverse};
  box-shadow: none;
  &:hover {
    border: 2px solid ${props => props.theme.grayscale?.g90};
  }
  &:focus {
    border: 2px solid ${props => props.theme.grayscale?.g90};
  }
  transition: border ${props => props.theme.transitions.quick} ease;
  resize: vertical;
`;
